import { render, staticRenderFns } from "./FormControlModulestructureColumnName.vue?vue&type=template&id=7b1c13df"
import script from "./FormControlModulestructureColumnName.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlModulestructureColumnName.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports